import $ from 'jquery'
import Gardener from 'scoreboard/components/gardener'
import { Transform } from 'stream'
import fileInfo from 'scoreboard/components/files/file-info'
import TopLevelNode from 'scoreboard/components/top-level-node'

const ALL_FILES = 'all-files'

/**
 * Gardener for FTP, Google, and Zapier connections (#13959)
 */
const RemoteFilesGardener = Gardener.extend({

	_url(opt) {
		const allowedExtensions = opt.allowedFileExtensions ?
			'?' + this.asParamArray(opt.allowedFileExtensions) : ''
		return `api/admin/import-connections/${opt.connectionId}/tree${allowedExtensions}`
	},

	/**
	 * #34547 This creates query parameters for the allowed extensions for this gardner.
	 * Ideally we would use $.param(), but that adds brackets to the url
	 * (eg. allowedFileExtensions[]=xls&allowedFileExtensions[]=xlsx), which
	 * causes Spring to not properly pick up the parameters
	 */
	asParamArray(allowedExtensions) {
		return allowedExtensions
			.map(ext => `allowedFileExtensions=${ext}`)
			.join('&')
	},

	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)

		if (this.options.allowAll) {
			treeOptions.stream = treeOptions.stream.pipe(this._disableFilesTransform())
			treeOptions.stream = new TopLevelNode({
				id : ALL_FILES,
				type: 'folder',
				icon: 'folder',
				label: '/'
			}).addToStream(treeOptions.stream)
		}

		treeOptions.stream = treeOptions.stream.pipe(this._iconTransform())
		treeOptions.accessors = { icon: 'icon' }
		return treeOptions
	},

	_iconTransform: function() {
		var self = this
		var icons = new Transform({ objectMode: true })
		icons._transform = function (node, enc, next) {
			let existingNode = self.tree.get(node.id) || node
			if (node.type === 'folder') {
				existingNode.icon = 'folder'
			} else if (fileInfo.icon(existingNode.label) === 'docs-spreadsheet') {
				existingNode.icon = 'docs-spreadsheet-mono'
			} else {
				existingNode.icon = fileInfo.icon(node.label)
				if (existingNode.icon === 'document-blank' && node.mimeType) {
					// Google Sheets don't have an extension
					existingNode.icon = fileInfo.iconForMimeType(node.mimeType)
				}
			}
			this.push(existingNode)
			next()
		}
		return icons
	},

	/**
	 * Disables files when multiple files is enabled
	 */
	_disableFilesTransform: function() {
		let self = this
		var transform = new Transform({ objectMode: true })
		transform._transform = function (node, enc, next) {
			let existingNode = self.tree.get(node.id) || node
			if (node.type !== 'folder') {
				existingNode.className = 'is-disabled'
			}

			this.push(existingNode)
			next()
		}
		return transform
	}
})

export default RemoteFilesGardener

RemoteFilesGardener.__filename__ = 'imports/remote-files-gardener.js'
